/**
 * Destaques do dashboard (PRD §29): o que a plataforma quer que o cliente descubra.
 * Dados em código, de propósito — mudar um destaque é um commit revisável, e nenhum
 * texto de marketing chega ao console sem passar por aqui.
 */
export interface Highlight {
  key: string;
  eyebrow: string;
  title: string;
  body: string;
  cta: string;
  to: string;
}

export const HIGHLIGHTS: readonly Highlight[] = [
  {
    key: 'mcp',
    eyebrow: 'Novo',
    title: 'Seu agente de IA no WhatsApp',
    body: 'Conecte o Claude Code, o Cursor ou qualquer cliente MCP e peça: “liste minhas instâncias”, “envie um oi para 5511…”.',
    cta: 'Conectar um agente',
    to: '/developers/mcp',
  },
  {
    key: 'pairing',
    eyebrow: 'Conexão',
    title: 'Conecte sem QR Code',
    body: 'Gere um código de pareamento e digite no WhatsApp em Aparelhos conectados. Ideal para números que não estão na sua mão.',
    cta: 'Ver instâncias',
    to: '/instances',
  },
  {
    key: 'explorer',
    eyebrow: 'Desenvolvedores',
    title: 'Execute a API sem sair do console',
    body: 'Monte a requisição, execute com a sua sessão e leve o código pronto em cURL, Node, PHP, Python, C# ou Java.',
    cta: 'Abrir o API Explorer',
    to: '/developers/explorer',
  },
  {
    key: 'plans',
    eyebrow: 'Planos',
    title: 'Pague por instância, no tier certo',
    body: 'Start ou Business, 1 ou 3 instâncias. Pix, cartão ou boleto, sem fidelidade. Trocar de plano leva um clique.',
    cta: 'Ver planos',
    to: '/billing',
  },
];

export interface DocCard {
  key: string;
  title: string;
  body: string;
  to: string;
}

export const DOC_CARDS: readonly DocCard[] = [
  {
    key: 'quickstart',
    title: 'Primeira mensagem em 5 minutos',
    body: 'Crie a instância, conecte o número, gere uma API key e envie um texto.',
    to: '/developers/explorer',
  },
  {
    key: 'webhooks',
    title: 'Receber mensagens',
    body: 'Cadastre um webhook, valide a assinatura e reprocesse entregas pela DLQ.',
    to: '/webhooks',
  },
  {
    key: 'keys',
    title: 'API keys e escopos',
    body: 'Uma chave por integração, com o mínimo de permissões e ambiente de teste.',
    to: '/developers/keys',
  },
  {
    key: 'integrations',
    title: 'Integrações',
    body: 'REST, SDK, MCP, n8n e automações: o caminho para cada uma.',
    to: '/integrations',
  },
];

export interface ChangelogEntry {
  date: string;
  title: string;
  body: string;
  to?: string;
}

/** Novidades, das mais recentes para as mais antigas. */
export const CHANGELOG: readonly ChangelogEntry[] = [
  {
    date: '2026-09-28',
    title: 'Servidor MCP e API Explorer em três colunas',
    body: 'Agentes de IA operam o WhatsApp com uma API key; o Explorer executa e gera código com os seus valores.',
    to: '/developers/mcp',
  },
  {
    date: '2026-09-28',
    title: 'Segundo fator e confirmação de e-mail',
    body: 'TOTP no login, verificação por código no cadastro e redefinição de senha por link de uso único.',
    to: '/settings',
  },
  {
    date: '2026-09-27',
    title: 'Planos por instância com Pix, cartão e boleto',
    body: 'Start e Business, 1 ou 3 instâncias. A assinatura ativa assim que o pagamento confirma.',
    to: '/billing',
  },
  {
    date: '2026-09-27',
    title: 'Código de pareamento',
    body: 'Conecte um número sem QR Code, direto do detalhe da instância.',
    to: '/instances',
  },
  {
    date: '2026-09-27',
    title: 'Console novo, tema escuro',
    body: 'Sidebar recolhível, tema claro/escuro e menu do usuário.',
  },
];
